/**
 * Ссылка в формате markdown `[текст](адрес)`. Допустима только в сообщении в ЛК НЛ: в пуше и смс НЛ показывает
 * текст как есть, и участник увидел бы скобки (add-nl-message-outbox, design.md, «Тексты по каналам и разметка»).
 * Один признак на проект — его используют и проверка текстов в админке, и zod-схемы очереди.
 */
const MARKDOWN_LINK = /\[[^\]\n]+\]\([^)\s]+\)/;

export function hasMarkdownLink(text: string): boolean {
  return MARKDOWN_LINK.test(text);
}

/** Кусок текста сообщения: обычный текст или ссылка `http(s)` (add-prize-win-messages, показ на лендинге). */
export type MessagePart = { text: string; href?: string };

const MARKDOWN_LINK_PARTS = /\[([^\]\n]+)\]\(([^)\s]+)\)/g;

/** Разбивает текст на обычные куски и markdown-ссылки; ссылка не на `http(s)` остаётся текстом как есть. */
export function splitMarkdownLinks(text: string): MessagePart[] {
  const parts: MessagePart[] = [];
  let last = 0;
  for (const m of text.matchAll(MARKDOWN_LINK_PARTS)) {
    if (!/^https?:\/\//i.test(m[2])) continue;
    if (m.index > last) parts.push({ text: text.slice(last, m.index) });
    parts.push({ text: m[1], href: m[2] });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}
